import type { ItemHealthLevel } from '@/common/api/types/dashboard/health';
import { HEALTH_LEVEL_SEVERITY } from '@/common/constants/status/itemHealth';
import { StatusBadge } from './StatusBadge';

interface HealthBadgeProps {
  healthLevel: ItemHealthLevel;
  label: string;
  count?: number;
  className?: string;
}

export const HealthBadge = ({ healthLevel, label, count, className }: HealthBadgeProps) => {
  return (
    <StatusBadge
      variant={HEALTH_LEVEL_SEVERITY[healthLevel]}
      label={label}
      count={count}
      className={className}
    />
  );
};
